import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import { responsiveBreakpoints } from "../../theme/themeVariables.js"

const Image = styled(Img)`
  width: 15vw;
  height: 15vw;
  @media (min-width: ${responsiveBreakpoints.desktop}) {
    width: 4vw;
    height: 4vw;
  }
  img {
    margin-bottom: 0;
    object-position: right center !important;
  }
`

const BarnSwallowThumb = () => {
  const { barnSwallowThumb } = useStaticQuery(graphql`
    query {
      barnSwallowThumb: file(relativePath: { eq: "protagonists/barn_swallow.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return <Image
            fluid={barnSwallowThumb.childImageSharp.fluid}
            alt="Barn Swallow"
          />
}

export default BarnSwallowThumb
